export const ADD_FEE_TO_BE_SAVED = "@iweb/ADD_FEE_TO_BE_SAVED"
export const REMOVE_FEE_TO_BE_SAVED = "@iweb/REMOVE_FEE_TO_BE_SAVED"
export const SAVED_FEES = "@iweb/SAVED_FEES"
export const GET_ALL_FEES = "@iweb/GET_ALL_FEES"
